<template>
    <div class="drpicker">
        <span class="date-picker-placeholder" v-bind:class="{opened: show}" v-on:click="show = !show" v-tooltip.bottom="'Pick dates'">
            <i class="fa fa-lg fa-calendar"></i>&nbsp;
            <span><i>{{ dateFieldName }}:</i></span>
            <span v-if="!from && !to"><i>All time</i></span>
            <span v-else-if="!from"><i>To: {{toWrapper.format("M/D/YY")}}</i></span>
            <span v-else-if="!to"><i>From: {{fromWrapper.format("M/D/YY")}}</i></span>
            <span v-else>{{fromWrapper.format("M/D/YY")}} - {{toWrapper.format("M/D/YY")}}</span>
        </span>
        <transition name="fade">
            <div v-if="show" class="date-picker">
                <form>
                    <div class="text-left">
                        <template v-if="allowFieldSelection">
                            <div class="form-group">
                                <FormulateInput type="select" :options="dateFields" v-model="dateField" label="Date Field"></FormulateInput>
                            </div>
                        </template>
                        <template v-else>
                            <h3>Date Field: <b>{{ dateFieldName }}</b></h3>
                        </template>
                    </div>
                    
                    <div class="form-group">
                        <label class="col-sm-2 text-left control-label">From</label>
                        <div class="col-sm-10 input-group">
                            <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
                            <input type="date" class="form-control" placeholder="From" v-model="from">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-sm-2 text-left control-label">To</label>
                        <div class="col-sm-10 input-group">
                            <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
                            <input type="date" class="form-control" placeholder="To" v-model="to">
                        </div>
                    </div>
                    <div class="form-group text-left">
                        <ul class="date-options">
                            <li v-for="o in options"><a @click="o.handler" >{{ o.label }}</a></li>
                        </ul>
                    </div>
                    <div class="text-right form-group">
                        <button type="button" class="btn btn-default" @click="cancel()">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="apply()">Apply</button>
                    </div>
                </form>
            </div>
        </transition>
    </div>
</template>

<script>
 export default {
     props: {
         datesRange: Object,
         dateFields: {
             type: Array,
             default() {
                 return [{ id: '', value: '', name: 'default', label: 'default' }];
             }
         },
         allowFieldSelection: Boolean
     },
     data () {
         var self = this;
         return {
             show: false,
             // This is the internal state
             from: null,
             to: null,
             dateField: '',
             fields: [],
             options: [
                 {"label": "Today",
                  "handler": function () {
                      self.from = moment().format("YYYY-MM-DD");
                      self.to = null;
                  }
                 },
                 {"label": "Yesterday",
                  "handler": function () {
                      self.from = moment().subtract(1,'days').format("YYYY-MM-DD");
                      self.to = moment().subtract(1,'days').format("YYYY-MM-DD");
                  }
                 },
                 {"label": "Last 7 days",
                  "handler": function () {
                      self.from = moment().subtract(6,'days').format("YYYY-MM-DD");
                      self.to = moment().format("YYYY-MM-DD");
                  }
                 },
                 {"label": "Current month",
                  "handler": function () {
                      self.from = moment().startOf('month').format("YYYY-MM-DD");
                      self.to = moment().format("YYYY-MM-DD");
                  }
                 },
                 {"label": "Last 30 days",
                  "handler": function () {
                      self.from = moment().subtract(29, "days").format("YYYY-MM-DD");
                      self.to = moment().format("YYYY-MM-DD");
                  }
                 },
                 {"label": "Past month",
                  "handler": function () {
                      self.from = moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD");
                      self.to = moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD");
                  }
                 },
                 {"label": "All time",
                  "handler": function () {
                      self.from = null;
                      self.to = null;
                  }
                 }
             ]
         }
     },
     created() {
         this.from = this.datesRange.from;
         this.to = this.datesRange.to;
         this.dateField = this.datesRange.date_field !== null ? this.datesRange.date_field : '';
     },
     computed: {
         dateFieldName () {
             let field = this.dateFields.find(item => item.id == this.dateField);
             if (field) {
                 return field.name;
             }
             else {
                 return '';
             }
         },
         fromWrapper () {
             if (this.from) {
                 return moment(this.from);
             }
             else {
                 return {
                     "format": function () {
                         return "open";
                     }
                 }
             }
         },
         
         toWrapper () {
             if (this.to) {
                 return moment(this.to);
             }
             else {
                 return {
                     "format": function () {
                         return "open";
                     }
                 }
             }
         }
     },
     watch: {
         datesRange: {
             handler: function (val, old) {
                 this.from = val.from;
                 this.to = val.to;
                 this.dateField = val.date_field !== null ? val.date_field : '';
             },
             deep: true
         }
     },
     mounted () {      
     },
     methods: {
         cancel () {
             this.from = this.datesRange.from;
             this.to = this.datesRange.to;
             this.dateField = this.datesRange.date_field;
             this.show = false;
         },
         apply () {
             this.show = false;
             this.push();
         },
         push() {
             this.$store.commit(
                 'pushDateRange',
                 {
                     date_field: this.dateField,
                     from: this.from,
                     to: this.to
                 }
             );
             this.$emit('dates-range-updated', {from: this.from, to: this.to, date_field: this.dateField});
         }
     }
 }
</script>


<style scoped>
.drpicker {
  min-width: 160px;
}
form.navbar-form .form-group .drpicker .fa-calendar {
  display: inline-block;
}

.date-picker-placeholder {
  display: inline-block;
  padding: 0px 6px;
  width: 100%;
  text-align: left;
}

.date-picket-placeholder .caret {
  float: right;
}

.date-picker-placeholder:hover,
.date-picker-placeholder.opened {
  cursor:pointer;
  color: #555;
  background: #ddd;
}

.date-picker {
  width: 60%;
  max-width: 300px;
  color: #333;
  background: #fefefe;
  padding: 10px;
  border: 1px solid #999;
  border-radius: 0px  0px 4px 4px;
  box-shadow: 2px 2px 6px #555;
  position: fixed;
  margin-top: 1px;
  z-index: 1000;
  
}

.date-options>li {
  line-height: 1.4em;
  text-decoration: underline;
  color: #555;
}

.date-options>li>a {
  cursor: pointer;
  color: #555!important;
}

</style>



// WEBPACK FOOTER //
// DateRangePicker.vue?415d2006